import React from 'react';
import { Box, Typography } from '@mui/material';
// import { colors } from '../../assets/styles/colors';

const ErrorMessage = (): JSX.Element => {
  // console.log('yes was error...');
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FFF',
        minHeight: 480,
      }}>
      <Typography sx={{ fontSize: 22 }} color="text.primary">
        System Error !!
      </Typography>
    </Box>
  );
};

export default ErrorMessage;
